import React, { Component } from 'react';
import { t } from 'i18next';
import { axisFormatter } from './reportHelpers/axisFormatter';
import Loading from '../loading/Loading';

export default class ChartReport extends Component {
  static helperMsg(width, height, helperMsg, descExpanded) {
    return ! descExpanded
      ? (
        <div className="helperMsg"
          style={{
            height,
            width,
          }}
        >
          {helperMsg}
        </div>
      )
      : (
        <div style={{
          height,
          width,
        }}
        />
      );
  }

  static chartStatus(width, height, data) {
    return (
      <div className="filler"
        style={{
          height,
          width,
        }}
      >
        {data === t('unableToFetchData')
          ? t('unableToFetchData')
          : <Loading size={60} />}

      </div>
    );
  }

  static chartMargin() {
    return {
      bottom: 59,
      left: 50,
      right: 15,
      top: 10,
    };
  }

  static xAxis(xLabel) {
    return {
      label: t(`axis.${xLabel}`),
      tickFormat: x => x,
    };
  }

  static yAxis(yLabel) {
    return {
      label: t(`axis.${yLabel}`),
      tickFormat: y => axisFormatter(y),
    };
  }

  static tooltipContainer(title) {
    return (
      <div id={`axis_tooltips_${title}`}
        className="tooltip-container"
      />
    );
  }

  generateTooltips() {
    function hide(evt, element) {
      element.setAttribute('style', `top:${evt.clientY + 15}px; left:${evt.clientX}px;`);
      element.setAttribute('class', 'tooltip axis-tooltip hide-tooltip');
    }
    function show(evt, element) {
      element.setAttribute('style', `top:${evt.clientY + 15}px; left:${evt.clientX}px;`);
      element.setAttribute('class', 'tooltip axis-tooltip show-tooltip');
    }
    this.tooltipUpdate(show, hide);
  }

  tooltipUpdate(show, hide) {
    for (const axis of [document.getElementById(this.props.title).getElementsByClassName('tick')]) {
      if (axis.length > 0) {
        const copyAxis = Array.from(axis);
        copyAxis.forEach((gs) => {
          const texts = gs.getElementsByTagNameNS('http://www.w3.org/2000/svg', 'text');
          const textSVG = texts[0];
          const oldValue = textSVG.innerHTML;
          const newValue = axisFormatter(textSVG.innerHTML);
          if (newValue.endsWith('...') && texts.length < 2 && ! textSVG.innerHTML.endsWith('...')) {
            const newDiv = document.createElement('div');
            newDiv.setAttribute('style', 'display:none; z-index: 10');
            newDiv.innerHTML = oldValue;
            textSVG.innerHTML = newValue;
            gs.onmouseover = evt => show(evt, newDiv);
            gs.onmouseout = evt => hide(evt, newDiv);
            document.getElementById(`axis_tooltips_${this.props.title}`).appendChild(newDiv);
          }
        });
      }
    }
  }
}
